import { GetServerSidePropsContext } from "next";
import { NextSeo, NextSeoProps } from "next-seo";

import { ReactNode } from "react";
import Layout from "components/layout";
import { MediaHeader } from "features/media/components/atoms/MediaHeader";
import { MediaNav } from "features/media/components/atoms/MediaNav";
import { useTopicList } from "repositories/hooks/useTopicList";
import { useRouter } from "next/router";
import getNextSeoProps from "utils/ssr/getNextSeoProps";
import { ColumnListLayout } from "features/media/components/template/ColumnListLayout";
import { useTopicCategoryList } from "repositories/hooks/useTopicCategoryList";

const perPage = 10;

interface Props {
  nextSeoProps: NextSeoProps;
}

const PressHome = ({ nextSeoProps }: Props) => {
  const { query } = useRouter();

  const currentPage = query.page || 1;

  const { topics, meta, isLoading } = useTopicList("press", {
    page: currentPage,
    limit: perPage,
  });
  const { categories } = useTopicCategoryList("press");

  return (
    <>
      <NextSeo {...nextSeoProps} />
      <ColumnListLayout
        title="恋愛"
        topics={topics}
        categories={categories}
        currentPage={currentPage}
        totalPage={meta.totalPages}
        isLoading={isLoading}
      />
    </>
  );
};

export default PressHome;

PressHome.getLayout = (page: ReactNode) => {
  return (
    <Layout header={<MediaHeader />} nav={null}>
      <MediaNav />
      {page}
    </Layout>
  );
};

export async function getServerSideProps(ctx: GetServerSidePropsContext) {
  const { page } = ctx.query;

  if (page && Number(page) > 1) {
    return {
      redirect: {
        destination: `/press/column?page=${page}`,
        permanent: false,
      },
    };
  }

  const title = "MIROR PRESSのまとめ一覧";
  const description =
    "MIROR PRESSは、女性の悩みに寄り添う恋愛・婚活メディアです。出会い、失恋、復縁、婚期、結婚、不倫、再婚、家庭、キャリアなどの女性特有の悩みに役立つ情報が満載です。";
  const url = "https://miror.jp/press/column";

  const nextSeoProps = getNextSeoProps(ctx, {
    title,
    description,
    url,
    options: {
      additionalLinkTags: [{ rel: "icon", href: "/favicon.ico" }],
      openGraph: {
        title,
        description,
        url,
        type: "article",
        site_name: "ミラープレス",
      },
    },
  });

  return {
    props: {
      nextSeoProps,
    },
  };
}
